var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "history_icon copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history_icon-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32846733,1.48151823 C6.69016195,1.4771172 5.11466972,2.1080731 3.93673876,3.24032367 L4.36481166,1.48149002 C4.36481166,1.21556602 4.1480297,1 3.88060569,1 C3.61318169,1 3.39642809,1.21556602 3.39642809,1.48149002 L2.9683552,4.37037373 C2.96829845,4.57770191 3.10172675,4.76178361 3.29955696,4.82729131 L5.85283004,5.11861041 C6.10686299,5.20265323 6.38132297,5.06596727 6.46581148,4.81335922 C6.55032836,4.56075117 6.4128714,4.28783065 6.15883845,4.20381604 L4.36576335,4.16575387 C6.34721464,2.02010885 9.70272484,1.87797802 11.8604728,3.8483152 C14.0182208,5.81865238 14.1611534,9.15534127 12.1797021,11.3009863 C10.1982508,13.4466313 6.84274059,13.5887621 4.6849926,11.618425 C3.36211477,10.410454 2.74379961,8.61886653 3.04197765,6.85769131 C3.08887473,6.59588622 2.9134859,6.34587365 2.65023241,6.29921141 C2.38697893,6.25254917 2.13552774,6.42698245 2.08860229,6.68875932 C2.08809161,6.69160871 2.08760931,6.69448631 2.08715537,6.69733569 C2.02919365,7.04213976 2,7.39111917 2,7.74069103 C2.00394355,11.1959539 4.8197827,13.9959988 8.29450737,14.0000232 C11.7708776,14.0093148 14.5966465,11.2145173 14.6060838,7.75764629 C14.6153997,4.30077533 11.8048659,1.49085632 8.32846733,1.48151823 Z",
    id: "Path",
    stroke: "#8C8E98",
    strokeWidth: 0.5,
    fill: "#8D8E97",
    fillRule: "nonzero",
    transform: "translate(8.303042, 7.500012) rotate(-90.000000) translate(-8.303042, -7.500012) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,4.5 C8.62969577,4.5 8.94349096,4.78215388 8.99315338,5.14822944 L9,5.25 L8.999,7.347 L10.5525836,8.53962588 C10.85129,8.7689079 10.9296084,9.17886008 10.7518902,9.49836675 L10.690858,9.59123427 C10.461576,9.88994068 10.0516238,9.96825907 9.73211714,9.79054086 L9.63924962,9.72950865 L7.793333,8.31261409 C7.63922679,8.19432476 7.53826079,8.0219228 7.50888619,7.83283111 L7.5,7.71767271 L7.5,5.25 C7.5,4.83578644 7.83578644,4.5 8.25,4.5 Z",
    id: "Line-2",
    fill: "#8D8E97",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.939e12f67a60a555545dd8c32f198ac0.svg";
export { ForwardRef as ReactComponent };